import { get } from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";
import { Field } from "formik";

import FormikDetailsPanel from "../forms/formik/FormikDetailsPanel/FormikDetailsPanel.jsx";
import FormikTimezoneDropdown from "../forms/time/FormikTimezoneDropdown.jsx";
import FormikComplexDateRange from "../forms/time/FormikComplexDateRange.jsx";
import FormikWeekDayMultiSelect from "../forms/time/FormikWeekDayMultiSelect.jsx";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ScheduleCorePanel extends Component {
  static propTypes = {
    readOnly: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    violationErrors: PropTypes.object,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    readOnly: false,
    disabled: false,
    copyKey: "schedule.actions"
  };

  // -- RENDER -- //

  render() {
    const { readOnly, disabled, violationErrors, copy } = this.props;

    return (
      <Segment className="clear-both">
        <Header as="h3" className="clear-both">{`${copy(
          "schedule.details"
        )}`}</Header>

        <FormikDetailsPanel
          readOnly={readOnly}
          disabled={disabled}
          apiErrors={violationErrors}
        />

        <Field
          name={"timezone"}
          label={`${copy("forms.week_day_select.label")}`}
          placeholder={`${copy("forms.week_day_select.placeholder")}`}
          readOnly={readOnly}
          disabled={disabled}
          required={true}
          apiErrors={violationErrors}
          component={FormikTimezoneDropdown}
        />

        <Field
          // min="2019-04-03T23:00:00.000Z"
          // max="2019-04-28T23:00:00.000Z"
          name={"dates"}
          label={`${copy("forms.week_day_select.label")}`}
          placeholder={`${copy("forms.week_day_select.placeholder")}`}
          readOnly={readOnly}
          disabled={disabled}
          required={true}
          aggressiveClamping={true}
          apiErrors={violationErrors}
          component={FormikComplexDateRange}
        />

        <Field
          name={"days"}
          label={`${copy("forms.week_day_select.label")}`}
          placeholder={`${copy("forms.week_day_select.placeholder")}`}
          readOnly={readOnly}
          disabled={disabled}
          required={false}
          apiErrors={violationErrors}
          component={FormikWeekDayMultiSelect}
        />
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.locale.locale,
  defaultTimezone: get(state, "account.timezone", {}),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ScheduleCorePanel);
